import React from 'react';
import { Hero } from '../components/home/Hero';
import { HowItWorksTease } from '../components/home/HowItWorksTease';
import { ImpactCounters } from '../components/home/ImpactCounters';
import { FounderStory } from '../components/home/FounderStory';
import { PartnerLogos } from '../components/home/PartnerLogos';
import { Testimonial } from '../components/home/Testimonial';
import { DonationTiers } from '../components/home/DonationTiers';
import { Newsletter } from '../components/home/Newsletter';
export function HomePage() {
  return <>
      <Hero data-id="element-1222" />
      <HowItWorksTease data-id="element-1223" />
      <ImpactCounters data-id="element-1224" />
      <FounderStory data-id="element-1225" />
      <PartnerLogos data-id="element-1226" />
      <Testimonial data-id="element-1227" />
      <DonationTiers data-id="element-1228" />
      <Newsletter data-id="element-1229" />
    </>;
}